import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Login/login';
import { css } from '@patternfly/react-styles';
export var LoginMainFooterBandItem = function LoginMainFooterBandItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  return React.createElement("p", Object.assign({
    className: css("".concat(styles.loginMainFooterBand, "-item"), className)
  }, props), children);
};